import Logo from '../../../_metronic/assets/logo.png'
import { NumericFormat } from 'react-number-format'
import { useLocation, useNavigate } from 'react-router-dom'
import { useMerchantData } from '../hook'
import * as Yup from 'yup'
import { Field, Form, Formik } from 'formik'
import Flatpickr from 'react-flatpickr'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useCreateCampaign, useLaunchProgram } from '../context/useMutation'
import { OverlayTrigger } from 'react-bootstrap'
import SuccessImg from '../assets/success.png'
import Success2Img from '../assets/success-2.png'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { Stepper } from '../components/Stepper'

export default function BecomeAMerchantLanding() {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation() as any

  const { merchantData } = useMerchantData()
  const { mutateAsync, isLoading } = useCreateCampaign()
  const { mutateAsync: launchProgram, isLoading: launchProgramLoading } = useLaunchProgram()
  const [launchSchedule, setLaunchSchedule] = useState(false)
  const [successModal, setSuccessModal] = useState(false)

  const initialValues = {
    expirationRadio: 'never', // backend'e gitmez. sadece ön tarafta select'i kontrol etmek için kullanılır.
    customerRadio: 'all', // backend'e gitmez. sadece ön tarafta select'i kontrol etmek için kullanılır.
    productRadio: 'all', // backend'e gitmez. sadece ön tarafta select'i kontrol etmek için kullanılır.
    productInSelectionType: '1',
    productOutSelectionType: '0',
    customerInSelectionType: '1',
    customerOutSelectionType: '0',
    campaignData: {
      promotionID: 'xxxxx',
      name: 'Basic Point - Always On',
      description: '',
      status: 1,
      startDate: moment().local().utc().format(),
      endDate: moment().local().add(10, 'years').utc().format(),
      workingDays: [0, 1, 2, 3, 4, 5, 6],
      workingStartTime: '',
      workingEndTime: '',
      hasActivated: false,
      promoCluster: 2,
      promoType: 11,
      promoGroup: 11,
      workerHoursStatus: false,
      order: 10,
      sub: 10,
      super: 10,
    },
    campaignPoint: {
      accrualPercentage: 0,
      fixedValue: 0,
      RedemptionValue: 1,
      activationType: 1,
      deferredTime: '',
      everyAfterAccrualMonth: [],
      everyAfterAccrualWeek: [],
      everyAfterAccrualDay: [],
      everyAfterAccrualTime: '',
      expirationType: 0,
      expirationValue: 0,
      expirationTime: '',
      expirationDate: '',
      multiplier: 0,
      pointsToBeEarned: 0,
      amountToBeSpent: 1.0,
    },
    campaignPriceClusterList: [
      {
        min: 1,
        max: 999999,
        value: 1,
        rewardType: 4,
      },
    ],
  }

  const validSchema = Yup.object().shape({
    campaignData: Yup.object().shape({
      name: Yup.string().default('Basic Point - Always On'),
      description: Yup.string(),
      startDate: Yup.string().required(
        intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })
      ),
      endDate: Yup.string().required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })),
    }),
    campaignPoint: Yup.object().shape({
      amountToBeSpent: Yup.number()
        .required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' }))
        .min(1, intl.formatMessage({ id: 'GLOBAL.VALIDATION.MIN_LENGTH_FIELD' }, { length: 1 }))
        .max(400, intl.formatMessage({ id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD' }, { length: 400 })),
    }),
    campaignPriceClusterList: Yup.array().of(
      Yup.object().shape({
        min: Yup.number().nullable().default(1),
        max: Yup.number().nullable().default(999999),
        value: Yup.number()
          .nullable()
          .required(intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' }))
          // .min(0, 'Value must be greater than 0')
          // .max(100, 'Value must be less than 100'),
          .min(1, intl.formatMessage({ id: 'GLOBAL.ERROR.MIN_LIMIT_INPUT' }, { length: 1 }))
          .max(20, intl.formatMessage({ id: 'GLOBAL.ERROR.MAX_LIMIT_INPUT' }, { length: 20 })),
        rewardType: Yup.number().nullable(),
      })
    ),
  })

  useEffect(() => {
    if (!location?.state?.subscriptionID) {
      navigate('/')
    }

    if (!merchantData?.merchantID || merchantData.merchantID === '') {
      navigate('/')
    }
  }, [merchantData.merchantID, navigate, location?.state?.subscriptionID])

  const onSubmit = async (values: any) => {
    values.endDate = moment(values.startDate).add(10, 'years').utc().format()

    const campaignResponse = await mutateAsync({
      values,
      products: [],
      uploadFileIdsState: [],
      vipTierIDList: [],
      isQuickStart: true,
      userID: merchantData?.userID || '',
      token: merchantData?.token || '',
    })

    const launchProgramResponse = await launchProgram({
      userID: merchantData?.userID || '',
      merchantID: merchantData?.merchantID || '',
      token: merchantData?.token || '',
    })

    localStorage.removeItem('selectedPackage')

    if (campaignResponse && launchProgramResponse) {
      setSuccessModal(true)
    } else {
      toast.error('Failed to launch the Loyalty Program')
    }
  }

  function isCampaignPriceClusterErrorValue(error: any): error is { value: string } {
    return error && typeof error.value === 'string'
  }

  function isCampaignPriceClusterAmountToBeSpent(error: any): error is { amountToBeSpent: string } {
    return error && typeof error.amountToBeSpent === 'string'
  }

  const minDate = new Date();
  const maxDate = new Date(minDate.getTime() + 30 * 24 * 60 * 60 * 1000);

  return (
    <div className='d-flex flex-column flex-root px-10 bg-white' id='kt_app_root'>
      <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
        <div className='flex-column-fluid'>
          <div id='' className=''>
            <div className='card '>
              <div
                className='container-fluid d-flex align-items-stretch justify-content-between pt-8'
                id='kt_app_header_container'
              >
                <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                  <div
                    className='btn btn-icon btn-color-gray-500 btn-active-color-primary w-35px h-35px ms-n2 me-2 d-flex d-lg-none'
                    id='kt_app_sidebar_mobile_toggle'
                  >
                    <i className='ki-outline ki-abstract-14 fs-1'></i>
                  </div>

                  <a href='../sign-in'>
                    <img alt='Logo' src={Logo} style={{ width: '250px' }} />
                  </a>
                </div>

                <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                  <div className='d-flex align-items-stretch' id='kt_app_header_menu_wrapper'></div>
                </div>
              </div>

              <Stepper activeStep={3} />

              <div className='card-body px-15'>
                <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
                  <div className='flex-column-fluid'>
                    <div id='' className=''>
                      <div className='card-title'>
                        <h3 className='text-start'>
                          {/* Launch your loyalty program! */}
                          {intl.formatMessage({ id: 'LANDING.LAUNCH_LOYALTY_PROGRAM' })}
                        </h3>
                        <p className='text-start fs-6'>
                          {/* Let's launch your loyalty program by setting the basic Point Award rules. */}
                          {intl.formatMessage({ id: 'LANDING.LAUNCH_LOYALTY_PROGRAM_DESC' })}
                        </p>
                      </div>

                      <div className='card-body p-0'>
                        <div>
                          <div
                            className='alert border d-flex flex-column flex-sm-row p-5 mb-10 w-75 row'
                            style={{
                              backgroundColor: '#60026b',
                            }}
                          >
                            <div className='d-flex flex-column pe-0 pe-sm-10'>
                              <div>
                                <div className='d-flex align-items-center'>
                                  <i className='ki-duotone ki-notification-bing fs-2hx text-white me-4 mb-5 mb-sm-0'>
                                    <span className='path1'></span>
                                    <span className='path2'></span>
                                    <span className='path3'></span>
                                  </i>

                                  <div>
                                    <p className='p-0 m-0'>
                                      <h4 className='fw-semibold text-white'>
                                        {/* Important Note: */}
                                        {intl.formatMessage({ id: 'LANDING.IMPORTANT_NOTE' })}
                                      </h4>
                                      <h4 className='fw-normal fs-5 text-white'>
                                        {/* These basic rules will be applicable to all your
                                        transactions, products and members. */}
                                        {intl.formatMessage({ id: 'LANDING.IMPORTANT_NOTE_0' })}
                                      </h4>
                                      <h4 className='fw-normal fs-5 text-white'>
                                        {intl.formatMessage({ id: 'LANDING.IMPORTANT_NOTE_1' })}
                                      </h4>
                                      <h4 className='fw-normal fs-5 text-white'>
                                        {/* You can always set different point-based campaign rules by
                                        using "New Campaign Creation". */}
                                        {intl.formatMessage({ id: 'LANDING.IMPORTANT_NOTE_2' })}
                                      </h4>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <Formik
                            initialValues={initialValues}
                            validationSchema={validSchema}
                            onSubmit={onSubmit}
                            validateOnChange={true}
                            validateOnBlur={true}
                          >
                            {({ errors, touched, values, setFieldValue, setFieldTouched }) => (
                              <Form>
                                <div className=' row'>
                                  <div className='p-0'>
                                    <div className='row w-100 gap-10'>
                                      <div className='col-auto'>
                                        <h4 className='fw-semibold my-2'>
                                          {/* Points Earning Rule */}
                                          {intl.formatMessage({
                                            id: 'LANDING.POINTS_EARNING_RULE',
                                          })}
                                          <span className='mx-2'>-</span>
                                          <span className='fw-bold'>
                                            {intl.formatMessage({
                                              id: 'LANDING.POINTS_TITLE_OF_CAMPAIGN',
                                            })}
                                          </span>
                                        </h4>
                                        <span className='text-black'>
                                          {/* Please indicate the percentage of the total spending
                                          amount that you would like to award as points to your
                                          Members. */}
                                          {intl.formatMessage({
                                            id: 'LANDING.POINTS_EARNING_RULE_1',
                                          })}
                                          <br />
                                          <span
                                            className='text-black-50 w-100'
                                            dangerouslySetInnerHTML={{
                                              __html: intl.formatMessage({
                                                id: 'LANDING.POINTS_EARNING_RULE_2',
                                              }),
                                            }}
                                          >
                                            {/* For Example: “If you award 5% of a total spending of
                                            $100.00 as points, the member will earn 5 points, which
                                            is equivalent to $5.00 in spending{' '}
                                            <i>
                                              - if your point redemption rule is 1 point = $1.00
                                            </i>
                                            " */}
                                          </span>
                                        </span>

                                        <div>
                                          <NumericFormat
                                            allowNegative={false}
                                            suffix='%'
                                            decimalScale={2}
                                            thousandSeparator={true}
                                            placeholder='1.00%'
                                            allowLeadingZeros={false}
                                            maxLength={7}
                                            fixedDecimalScale={true}
                                            isAllowed={({ floatValue }) => {
                                              if (!floatValue) return true
                                              return Number(floatValue) <= 100.0
                                            }}
                                            aria-describedby='basic-addon2'
                                            className='form-control text-primary fw-bold py-5 mt-5 fs-4'
                                            value={values.campaignPriceClusterList?.[0]?.value}
                                            // onBlur={() =>
                                            //   setFieldTouched(
                                            //     'campaignPriceClusterList.0.min',
                                            //     true
                                            //   )
                                            // }
                                            onValueChange={({ value }) => {
                                              setFieldValue(
                                                'campaignPriceClusterList.[0].value',
                                                value
                                              )
                                            }}
                                            style={{ width: '25%' }}
                                          />

                                          <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                                            {isCampaignPriceClusterErrorValue(
                                              errors.campaignPriceClusterList?.[0]
                                            ) && errors.campaignPriceClusterList?.[0]?.value}
                                          </div>

                                          <span
                                            className='text-primary'
                                            style={{
                                              maxWidth: '40%',
                                            }}
                                          >
                                            {/* With a total spending of $100.00, your customer will earn
                                            {' '}
                                            {values.campaignPriceClusterList?.[0]?.value || '5.00'}{' '}
                                            points, which is equal to $
                                            {values.campaignPriceClusterList?.[0]?.value ||
                                              '5.00' ||
                                              '5.00'}{' '}
                                            worth of award points. */}

                                            {intl.formatMessage(
                                              { id: 'LANDING.POINTS_EARNING_RULE_3' },
                                              {
                                                value:
                                                  Number(
                                                    values.campaignPriceClusterList?.[0]?.value
                                                  )?.toFixed(0) || '5.00',
                                                value2:
                                                  Number(
                                                    values.campaignPriceClusterList?.[0]?.value
                                                  )?.toFixed(2) || '5.00',
                                              }
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                      <div className='col-auto'>
                                        <h4 className='fw-semibold my-2'>
                                          {/* Points Redemption Rule */}
                                          {intl.formatMessage({
                                            id: 'LANDING.POINTS_REDEMPTION_RULE',
                                          })}
                                        </h4>
                                        <span className='text-black w-75'>
                                          {/* Please specify the Dollar value corresponding to each
                                          point to be spent. General practice is to set 1 point
                                          equals to $1.00 */}
                                          {intl.formatMessage({
                                            id: 'LANDING.POINTS_REDEMPTION_RULE_1',
                                          })}
                                          <br />
                                          <span className='text-black-50'>
                                            {/* For Example: 'If you specify as $1.00, it means that 1
                                            point will be equal to $1.00 when Member redeems their
                                            points.' */}
                                            {intl.formatMessage({
                                              id: 'LANDING.POINTS_REDEMPTION_RULE_3',
                                            })}
                                          </span>
                                        </span>

                                        <div>
                                          <div className='d-flex align-items-center'>
                                            <NumericFormat
                                              allowNegative={false}
                                              prefix='$'
                                              decimalScale={2}
                                              thousandSeparator={true}
                                              placeholder='$ 1.00'
                                              fixedDecimalScale={true}
                                              disabled
                                              className='form-control py-5 mt-5 text-primary fw-bold fs-4 w-50'
                                              aria-describedby='basic-addon2'
                                              value={values.campaignPoint.amountToBeSpent}
                                              style={{ width: '25%' }}
                                            />
                                          </div>
                                          <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
                                            {isCampaignPriceClusterAmountToBeSpent(
                                              errors.campaignPoint
                                            ) && errors.campaignPoint?.amountToBeSpent}
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      className='d-flex alert bg-white border mt-10 justify-content-between pe-10'
                                      style={{
                                        width: '45%',
                                      }}
                                    >
                                      <div className='d-flex flex-column'>
                                        <h4 className='fw-semibold my-2 text-primary'>
                                          {/* Are you ready to set your rules and launch your Loyalty
                                          Program? */}
                                          {intl.formatMessage({
                                            id: 'LANDING.SET_RULES_LAUNCH_LOYALTY_PROGRAM',
                                          })}
                                        </h4>
                                        <div className='d-flex align-items-start gap-20'>
                                          <img
                                            className='mt-8'
                                            src={Success2Img}
                                            alt='Success'
                                            style={{ width: '125px', height: '125px' }}
                                          />

                                          <div className='d-flex flex-column mt-5'>
                                            <div className='d-flex flex-column'>
                                              <div className='d-flex align-items-center'>
                                                <Field
                                                  type='radio'
                                                  className='form-check-input me-2'
                                                  checked={!launchSchedule}
                                                  onChange={() => {
                                                    setLaunchSchedule(false)

                                                    setFieldValue(
                                                      'campaignData.startDate',
                                                      moment().local().utc().format()
                                                    )
                                                  }}
                                                />
                                                <label className='text-black'>
                                                  {/* Launch now */}
                                                  {intl.formatMessage({ id: 'LANDING.LAUNCH_NOW' })}
                                                </label>
                                              </div>
                                            </div>

                                            <div className='d-flex flex-column mt-5'>
                                              <div className='d-flex align-items-center'>
                                                <Field
                                                  type='radio'
                                                  className='form-check-input me-2'
                                                  checked={launchSchedule}
                                                  onChange={(e) => {
                                                    setLaunchSchedule(true)
                                                  }}
                                                />
                                                <label className='text-black'>
                                                  {/* Schedule Launch */}
                                                  {intl.formatMessage({
                                                    id: 'LANDING.SCHEDULE_LAUNCH',
                                                  })}
                                                </label>
                                              </div>

                                              {launchSchedule && (
                                                <div className='d-flex flex-column mt-5'>
                                                  <span className='text-black my-2'>
                                                    {/* Please choose the date on which you would like
                                                    to activate your Loyalty Program. */}
                                                    {intl.formatMessage({
                                                      id: 'LANDING.CHOOSE_DATE_ACTIVATE_LOYALTY_PROGRAM',
                                                    })}
                                                  </span>
                                                  <Flatpickr
                                                    className='form-control form-control-solid'
                                                    value={values.campaignData.startDate}
                                                    id='campaignData.startDate'
                                                    name='campaignData.startDate'
                                                    placeholder='MM-DD-YYYY HH:mm'
                                                    onChange={(date) => {
                                                      const dateValue = moment(date[0])
                                                        .local()
                                                        .utc()
                                                        .format()

                                                      setFieldValue(
                                                        'campaignData.startDate',
                                                        dateValue
                                                      )
                                                    }}
                                                    options={{
                                                      enableTime: true,
                                                      dateFormat: 'm-d-Y H:i',
                                                      // minDate: moment().format('m-d-Y HH:mm:ss'),
                                                      // maxDate: moment().add(30, 'days').format('m-d-Y HH:mm:ss'),
                                                      minDate,
                                                      maxDate,
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className='d-flex justify-content-center w-100 mt-20'>
                                      {isLoading ? (
                                        <div className='d-flex justify-content-center align-items-center'>
                                          <div className='spinner spinner-primary spinner-lg mr-15'></div>
                                          <span>
                                            {/* Launching... */}
                                            {intl.formatMessage({ id: 'LAUNCHING' })}
                                          </span>
                                        </div>
                                      ) : (
                                        <button
                                          type='submit'
                                          className='btn btn-primary d-flex align-items-center py-7 fs-3'
                                        >
                                          <i className='fas fa-arrow-right me-2 fs-3'></i>
                                          {/* Launch My Loyalty Program */}
                                          {intl.formatMessage({
                                            id: 'LANDING.LAUNCH_MY_LOYALTY_PROGRAM',
                                          })}
                                        </button>
                                      )}
                                    </div>
                                  </div>

                                  <Modal
                                    size='lg'
                                    dialogClassName='min-w-1000px'
                                    show={successModal}
                                    onHide={() => {
                                      return
                                    }}
                                    centered
                                  >
                                    <Modal.Body>
                                      <div className='d-flex justify-content-center align-items-center w-100 p-7 h-100'>
                                        <div className='d-flex min-w-400px align-items-end w-100 justify-content-start gap-15 h-100'>
                                          <div className='d-flex flex-column align-items-center h-100'>
                                            <img
                                              src={Success2Img}
                                              alt='Success'
                                              style={{
                                                width: '250px',
                                                height: '250px',
                                              }}
                                            />
                                            <div className='mt-8 w-100'>
                                              <h3 className='text-start text-primary fs-2x mt-5'>
                                                {/* Congratulations! */}
                                                {intl.formatMessage({
                                                  id: 'LANDING.CONGRATULATIONS',
                                                })}
                                              </h3>
                                              <p
                                                className='text-start fs-3 text-black w-100'
                                                dangerouslySetInnerHTML={{
                                                  __html: intl.formatMessage({
                                                    id: 'LANDING.CONGRATULATIONS_DESC',
                                                  }),
                                                }}
                                              >
                                                {/* Your loyalty program <br /> is now live. */}
                                              </p>

                                              <div className='d-flex justify-content-start w-50 mt-5'>
                                                <a
                                                  type='button'
                                                  className='btn btn-primary px-10 d-flex align-items-center w-100 text-center justify-content-center'
                                                  href='/sign-in'
                                                >
                                                  <i className='fa fa-arrow-right me-2 fs-3'></i>
                                                  {/* Sign In */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.GENERAL.SIGNIN_BUTTON',
                                                  })}
                                                </a>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            className={`w-100 d-flex flex-column flex-center rounded-3 py-15 px-10 text-white h-100`}
                                            style={{
                                              backgroundColor: '#1f0332',
                                              minWidth: '400px',
                                            }}
                                          >
                                            <div className='w-100 mb-10'>
                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* Monthly Transaction Limit */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.MONTHLY_TRANSACTION',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {
                                                    location?.state?.packageDetails
                                                      ?.monthlyOrderLimit
                                                  }
                                                </span>
                                              </div>

                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* Member Limit */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.MONTHLY_TRANSACTION_FEE_PER_LYT',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {
                                                    location?.state?.packageDetails
                                                      ?.monthlyTrxFeePerLylTrx
                                                  }
                                                </span>
                                              </div>

                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* Email */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.PT_COUPON_RED_FEE',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {
                                                    location?.state?.packageDetails
                                                      ?.pointCouponRedemptionFee
                                                  }
                                                </span>
                                              </div>

                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* SMS */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.LYLTY_MEMBERS_SERVED',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {
                                                    location?.state?.packageDetails
                                                      ?.loyaltyMembersServed
                                                  }
                                                </span>
                                              </div>

                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* Multi-Store */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.EmailPm',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {location?.state?.packageDetails?.email}
                                                </span>
                                              </div>

                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* Multi-Store */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.LYLTY_PORTAL_USER',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {location?.state?.packageDetails?.portalUser}
                                                </span>
                                              </div>

                                              <div className='d-flex align-items-center mb-5'>
                                                <span
                                                  className={`fw-semibold fs-6 flex-grow-1 pe-3 text-white`}
                                                >
                                                  {/* Multi-Store */}
                                                  {intl.formatMessage({
                                                    id: 'AUTH.SUBSCRIPTION.SUPPORT',
                                                  })}
                                                </span>
                                                <span className='fs-4'>
                                                  {location?.state?.packageDetails?.customerSupport}
                                                </span>
                                              </div>
                                            </div>
                                            <div className='d-flex justify-content-center align-items-center flex-column w-100'>
                                              <div className='w-100'>
                                                <h1 className={`fw-bolder text-white`}>
                                                  {location?.state?.packageDetails?.packageName}
                                                </h1>

                                                <div className='text-gray'>
                                                  <span className='mb-2 me-2 fs-2'>$</span>

                                                  <span
                                                    className='fs-3x fw-bold'
                                                    data-kt-plan-price-month='39'
                                                    data-kt-plan-price-annual='399'
                                                  >
                                                    {
                                                      location?.state?.packageDetails
                                                        ?.discountedPrice
                                                    }{' '}
                                                  </span>

                                                  <span className='fs-7 fw-semibold'>
                                                    /
                                                    <span data-kt-element='period'>
                                                      {intl.formatMessage({
                                                        id: 'AUTH.SUBSCRIPTION.MON',
                                                      })}
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Modal.Body>
                                  </Modal>
                                </div>
                              </Form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
